import React from 'react'
import {InputProps, TextInput} from './text'

type NumberInputProps = Omit<InputProps, 'value' | 'onChange'> & {
  value: number | undefined
  onChange: (value: number | undefined) => void
}

const numberRegex = /^\d*\.?\d*$/
const numbersOnly = (e: React.KeyboardEvent<HTMLDivElement>) => {
  // incantation based on library/text-editor.tsx which works
  const charStr = String.fromCharCode(e.charCode)
  // @ts-ignore - hmm this works, despite type warning, seems types are off here
  const attemptedValue = `${e.target.textContent}${charStr}`

  if (!numberRegex.test(attemptedValue)) {
    e.preventDefault()
  }
}

export const NumberInput = (props: NumberInputProps) => {
  const {value, onChange, ...rest} = props
  return (
    <TextInput
      {...rest}
      type="number"
      value={value ? String(value) : ''}
      onKeyPress={numbersOnly}
      onChange={s => {
        const n = Number(s.replace(/[^0-9.]/g, ''))
        return onChange(isNaN(n) ? undefined : n)
      }}
    />
  )
}
